import { PdfKitSource, PdfKitSourceFromJSON } from 'openapi/models/PdfKitSource'
import { UploadedFile } from 'openapi/models/UploadedFile'

export interface ReferenceWithFile {
  reference: PdfKitSource
  file: UploadedFile | null
}

export const computeReferenceKey = (reference: PdfKitSource) => {
  return `${reference.page}-${reference.text}`
}

export const convertReferencesToSources = (references: ReferenceWithFile[]) => {
  return references.map((reference, idx) => {
    const referenceSource = {
      id: reference.file?.id || idx,
      footnote: idx,
      sourceType: 'base',
      documentId: reference.file?.path,
      documentName: reference.file?.name,
      documentUrl: reference.file?.url,
      text: reference.reference.text,
      page: reference.reference.page,
      annotations: [],
    }
    return PdfKitSourceFromJSON(referenceSource)
  })
}
